export default {
  years: 'سنة | سنوات',
  months: 'شهر | شهور',
  weeks: 'أسبوع | أسابيع',
  days: 'يوم | أيام',
  hours: 'ساعة | ساعات',
  minutes: 'دقيقة | دقائق',
  seconds: 'ثانية | تواني'
}
